<template>
    <vs-prompt class="d-flex" buttons-hidden @close="close" :title="titleDialog + ' concepto'"
        :active.sync="showDialogConcept">
        <div style="padding: 20px">
            <vs-row>
                <vs-col vs-lg="2" vs-sm="4" vs-xs="12">
                    <label class="vs-input--label mb-0">Iniciales <span style="color: red;">*</span></label>
                    <vs-input class="inputx w-100" placeholder="INIT" v-model="initials" name="initials"
                        v-validate="'required'" type="Text" />
                </vs-col>
                <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
                    <label class="vs-input--label mb-0">Nombre <span style="color: red;">*</span></label>
                    <vs-input class="inputx w-100" placeholder="Ingrese el nombre" v-model="title" name="title"
                        v-validate="'required'" type="Text" />
                </vs-col>
                <vs-col vs-lg="3" vs-sm="4" vs-xs="12">
                    <label class="vs-input--label mb-0">Tipo de concepto <span style="color: red;">*</span></label>
                    <vs-select class="w-100" v-model="conceptType" placeholder="Seleccione el tipo de concepto">
                        <vs-select-item :key="index" :value="item.code" :text="item.title"
                            v-for="(item, index) in conceptTypes" v-validate="'required'" />
                    </vs-select>
                </vs-col>
                <vs-col vs-lg="3" vs-sm="4" vs-xs="12">
                    <label class="vs-input--label mb-0">Tipo de valor <span style="color: red;">*</span></label>
                    <vs-select class="w-100" v-model="valueType" placeholder="Seleccione el tipo de valor">
                        <vs-select-item :key="index" :value="item.code" :text="item.title"
                            v-for="(item, index) in valueTypes" v-validate="'required'" />
                    </vs-select>
                </vs-col>
            </vs-row>
            <br>
            <vs-row>
                <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                    <label class="vs-input--label mb-0">Concepto </label>
                    <vs-select class="w-100" v-model="concept" placeholder="Busque y seleccione el concepto" autocomplete>
                        <vs-select-item :key="index" :value="item.code" :text="item.title"
                            v-for="(item, index) in concepts" />
                    </vs-select>
                </vs-col>
                <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                    <vs-button icon="add" color="primary" class="flex-shrink-0 ml-auto" style="margin-top: 20px;"
                        :disabled="disabledAddConcept" @click="relateConcept()">Relacionar concepto</vs-button>
                </vs-col>
            </vs-row>
            <br>
            <vs-row>
                <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
                    <h5 style="margin-top: 5px;">Conceptos relacionados</h5>
                </vs-col>
            </vs-row>
            <br>
            <vs-row>
                <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                    <vs-table id="relateConcepts" ref="relateConcepts" stripe pagination max-items="2"
                        :data="listRelateConcepts" class="text-nowrap">
                        <template slot="thead">
                            <vs-th sort-key="relateCode">Código</vs-th>
                            <vs-th sort-key="relateConcept">Concepto</vs-th>
                            <vs-th sort-key="relateActions">Acciones</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].code" style="width: 100px;">
                                    <div>
                                        <span class=" badge-pill ">{{ data[indextr].code }}</span>
                                    </div>
                                </vs-td>
                                <vs-td :data="data[indextr].title">
                                    <div>
                                        <h5 class="mb-0 font-16">
                                            {{ data[indextr].title }}
                                        </h5>
                                    </div>
                                </vs-td>
                                <vs-td>
                                    <div class="d-flex align-items-center">
                                        <vs-button color="danger" type="filled" icon="delete"
                                            @click="removeConcept([indextr])" style="margin-right: 5px;"></vs-button>
                                    </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-col>
            </vs-row>
            <br>
            <vs-row class="d-flex justify-content-end">
                <vs-col vs-lg="2" vs-sm="4" vs-xs="12">
                    <div class="d-flex">
                        <vs-button color="danger" class="flex-shrink-0 ml-auto" style="margin-top: 0px;"
                            :disabled="disabledDeleteConcept" @click="deleteConcept()">Eliminar concepto</vs-button>
                    </div>
                </vs-col>
                <vs-col vs-lg="2" vs-sm="6" vs-xs="12">
                    <div class="d-flex">
                        <vs-button color="rgb(255,186,0)" class="flex-shrink-0 ml-auto" style="margin-top: 0px;"
                            @click="close()">Cancelar</vs-button>
                    </div>
                </vs-col>
                <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
                    <div class="d-flex">
                        <vs-button color="primary" class="flex-shrink-0 ml-auto" style="margin-top: 0px;"
                            :disabled="disabledSaveConcept" @click="saveConcept()">Guardar concepto</vs-button>
                    </div>
                </vs-col>
            </vs-row>
        </div>
    </vs-prompt>
</template>
<style>
.vs-dialog {
    min-width: 800px !important;
}
</style>
  
<script>
import { ROUTES } from "@/global/api_routes";
import { configToast, TOAST_TYPES } from "@/global/toast";
import EConceptType from '@/global/lasting/EConceptType';

export default {
    name: "DialogConcepts",
    props: [
        'openDialogConcept',
        'concepts',
        'company',
        'conceptEdit',
        'titleDialog',
        'conceptNew'
    ],
    data: () => ({
        showDialogConcept: false,
        title: null,
        conceptType: null,
        conceptTypes: EConceptType,
        valueType: null,
        valueTypes: [{ code: 'S', title: 'Suma' }, { code: 'I', title: 'Informativo' }],
        concept: null,
        listRelateConcepts: [],
        listConcepts: [],
        actualCode: null,
        numeral: null,
        disabledAddConcept: true,
        disabledSaveConcept: true,
        disabledDeleteConcept: true,
        initials: null,
        searchConceptsRelates: []
    }),
    watch: {
        openDialogConcept() {
            this.showDialogConcept = this.openDialogConcept;
        },
        concepts() {
            this.listConcepts = this.concepts;
        },
        concept() {
            this.disabledAddConcept = this.concept ? false : true;
        },
        title() {
            this.validateFields();
        },
        conceptType() {
            this.validateFields();
        },
        valueType() {
            this.validateFields();
        },
        conceptEdit() {
            if (this.conceptEdit) {
                this.getConcept();
            }
            this.disabledDeleteConcept = this.conceptEdit ? false : true;
        },
        conceptNew() {
            if (this.conceptNew) {
                this.cleanForm();
                this.actualCode = null;
                this.listRelateConcepts = [];
            }
        }
    },
    mounted() {
        if (this.conceptEdit) { this.this.getConcept(); }
        if (this.conceptNew) {
            this.cleanForm();
            this.actualCode = null;
            this.listRelateConcepts = [];
        }
    },
    methods: {
        toast(message, type = TOAST_TYPES.INFO) {
            const instance = configToast(this, "#rates_container");
            return instance.open(message, type);
        },
        close() {
            this.$emit('close');
        },
        relateConcept() {
            this.listRelateConcepts.push({
                code: this.concept,
                title: this.concepts.find(e => e.code === this.concept).title
            });
            this.concept = null;
        },
        removeConcept(concept) {
            if (this.listRelateConcepts[concept].code) {
                this.$vs.loading()
                this.$http
                    .delete(ROUTES.DASHBOARD.CONCEPTS.DELETE_CONCEPT_RELATED, {
                        params: {
                            concept: this.actualCode,
                            conceptRelated: this.listRelateConcepts[concept].code,
                        },
                    })
                    .then(({ data }) => {
                        this.$vs.loading.close();
                        if (data.code > 0) {
                            this.toast(
                                "El concepto relacionado se ha eliminado correctamente",
                                TOAST_TYPES.SUCCESS
                            );
                            return;
                        }
                        this.toast(data.message, TOAST_TYPES.ERROR);
                    });
            }
            this.listRelateConcepts.splice(concept, 1);
        },
        saveConcept() {
            this.$validator.validateAll().then((result) => {
                if (!result) {
                    return;
                }
                this.$vs.loading()
                const method = this.actualCode ? "put" : "post";
                this.$http[method](ROUTES.DASHBOARD.CONCEPTS.SAVE, {
                    code: this.actualCode,
                    numeral: this.numeral ? this.numeral : 1,
                    title: this.title,
                    initials: this.initials.toUpperCase(),
                    valueType: this.valueType,
                    company: { code: this.company },
                    conceptType: this.conceptType,
                    relatedsList: this.getRelatedsList()
                })
                    .then(({ data }) => {
                        if (data.code > 0) {
                            this.toast(
                                this.actualCode
                                    ? "Se ha actualizado el registro"
                                    : "Se ha registrado el registro",
                                TOAST_TYPES.SUCCESS
                            );
                            this.$validator.reset();
                            this.$emit('close', data.info);
                            this.cleanForm();
                            return;
                        }
                        else {
                            this.toast(data.message, TOAST_TYPES.ERROR);
                            this.$vs.loading.close();
                        }
                    })
                    .finally(() => { this.$vs.loading.close(); });
            });
        },
        getConceptTypes() {
            this.$http.get(ROUTES.DASHBOARD.CONCEPTS.GET_TYPES).then(({ data }) => {
                if (data.code > 0) {
                    this.conceptTypes = data.info;
                }
            });
        },
        cleanForm() {
            this.title = null;
            this.conceptType = null;
            this.concept = null;
            this.actualCode = null;
            this.numeral = null;
            this.listRelateConcepts = [];
            this.initials = null;
            this.valueType = null;
        },
        getRelatedsList() {
            let indice = null;
            if (this.searchConceptsRelates.length > 0) {
                this.searchConceptsRelates.forEach(sc => {
                    indice = this.listRelateConcepts.findIndex(rc => rc.code === sc.code);
                    this.listRelateConcepts.splice(indice, 1);
                });
            }
            return this.listRelateConcepts.length > 0 ? this.listRelateConcepts.map((item) => ({
                related: { code: item.code }
            })) : [];
        },
        validateFields() {
            if (this.title && this.conceptType && this.valueType) {
                this.disabledSaveConcept = false;
            }
            else {
                this.disabledSaveConcept = true;
            }
        },
        async getConcept() {
            this.listRelateConcepts = [];
            if (this.conceptEdit) {
                this.actualCode = this.conceptEdit.code;
                this.title = this.conceptEdit.title;
                this.conceptType = this.conceptEdit.conceptType;
                this.valueType = this.conceptEdit.valueType;
                this.initials = this.conceptEdit.initials;
                this.searchConceptsRelates = await this.getConceptsRelates(this.conceptEdit.code);
                if (this.searchConceptsRelates.length > 0) {
                    this.searchConceptsRelates.forEach(async related => {
                        this.listRelateConcepts.push({
                            code: related.code,
                            title: related.title
                        });
                    });
                }
                else {
                    this.listRelateConcepts = [];
                }
            }
        },
        getConceptsRelates(concept) {
            return new Promise((resolve) => {
                let relates = [];
                this.$vs.loading();
                this.$http
                    .get(ROUTES.DASHBOARD.CONCEPTS.LIST_CONCEPT_RELATEDS,
                        {
                            params: { conceptCode: concept }
                        })
                    .then(({ data }) => {
                        if (data.code > 0) {
                            data.info.forEach(related => {
                                relates.push({
                                    code: related.code,
                                    title: related.title
                                })
                                resolve(relates);
                            });
                        }
                        else {
                            resolve("");
                        }
                    }).finally(() => {
                        this.$vs.loading.close();
                    });
            });
        },
        deleteConcept() {
            this.$vs.loading()
            this.$http
                .delete(ROUTES.DASHBOARD.CONCEPTS.DELETE_CONCEPT, {
                    params: {
                        conceptCode: this.conceptEdit.code,
                    },
                })
                .then(({ data }) => {
                    this.$vs.loading.close();
                    if (data.code > 0) {
                        this.toast(
                            "El concepto se ha eliminado correctamente",
                            TOAST_TYPES.SUCCESS
                        );
                        this.$emit('closeEdit');
                        this.close();
                        return;
                    }
                    this.toast(data.message, TOAST_TYPES.ERROR);
                });
        }
    }
};
</script>